import { ChevronDownIcon } from '@/components/Icons';
import { cn } from '@/lib/cn';

type ExpandToggleProps = {
    isExpanded: boolean;
    className?: string;
    variant?: 'action';
};

export const ExpandToggle = ({
    isExpanded,
    className,
    variant,
}: ExpandToggleProps) => {
    return (
        <ChevronDownIcon
            variant={variant}
            className={cn(
                'shrink-0 cursor-pointer transition-transform',
                {
                    'rotate-180': isExpanded,
                },
                className,
            )}
        />
    );
};
